module.exports = __webpack_public_path__ + "img/human-error-image.e6c1ce6b.png";